// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export enum AlertType {
    Success = 'success',
    Error = 'error',
    Info = 'info',
    Warning = 'warning',
}
